import './assets/css/webshop.scss'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useSearchStore } from './components/Search/store'
import { defineCustomElement } from 'vue'
import SearchBar from './components/Search/SearchBar/index.ce.vue';
import i18nHost  from './components/i18nHost.ce.vue';
import { searchStorePlugin } from './components/Search/store/searchStorePlugin'

// Create pinia instance and register plugins
const pinia = createPinia()
pinia.use(searchStorePlugin)
const app = createApp({})
app.use(pinia)

// Create and expose store instance
//@ts-ignore
window.__PINIA_SEARCH_STORE__ = useSearchStore()

customElements.define('sai-vue3wc-i18n-host', defineCustomElement(i18nHost))
customElements.define('sai-vue3wc-search-bar', defineCustomElement(SearchBar))



// import { wrapWithPluginsLazy } from './utils/wrapWithPlugins'
// customElements.define('sai-vue3wc-test-component', wrapWithPluginsLazy(() => import('./components/TestComponent/index.vue')))
